import { observer } from "mobx-react";
import React from "react";
import { LLMClassifierBuilderStore } from "../Stores/LLMClassifierBuilderStore";
import { useStore } from "utils/useStore";
import { LLMConfigurationBuilderContext } from "./LLMConfigurationBuilderContext";

/** Observed so switching the builder type puts the new builder in the context. */
export const LLMConfigurationBuilderProvider = observer(function (
    props: React.PropsWithChildren,
) {
    const store = useStore(LLMClassifierBuilderStore);

    return (
        <LLMConfigurationBuilderContext.Provider
            value={store.classifier.implementation.configurationBuilder}
        >
            {props.children}
        </LLMConfigurationBuilderContext.Provider>
    );
});
